export default {
  footer: {
    tagline: 'Plateforme de gestion des livraisons propulsée par l\'IA pour automatiser le dispatch, optimiser les tournées et satisfaire les clients.',
    aiCommandHint:
      'Centre de commande IA : allocation autonome transporteurs et chauffeurs, planification agentique, alertes intelligentes et agents IA — une seule tour de contrôle.',
    product: 'Produit',
    builtFor: 'Par secteur',
    resources: 'Ressources',
    company: 'Entreprise',
    compare: 'Comparer',
    links: {
      compareHub: 'Comparer toutes les plateformes',
      howItWorks: 'Comment ça marche',
      brandedTracking: 'Suivi avec marque',
      routePlanner: 'Planificateur de tournées',
      aiAgents: 'Agents IA',
      autoAllocation: 'Allocation automatique',
      driverApp: 'App chauffeur',
      cashManagement: 'Gestion du cash',
      proofOfDelivery: 'Preuve de livraison',
      reportsAnalytics: 'Rapports et analyses',
      restaurants: 'Restaurants et QSR',
      pharmacies: 'Pharmacies',
      retail: 'Retail',
      ecommerce: 'E-commerce',
      couriers: 'Courriers et logistique',
      grocery: 'Supermarchés',
      allIndustries: 'Tous les secteurs',
      caseStudies: 'Études de cas',
      blog: 'Blog',
      roiCalculator: 'Calculateur ROI',
      whitepapers: 'Whitepapers',
      aboutUs: 'À propos',
      pricing: 'Tarifs',
      partners: 'Partenaires',
      integrations: 'Intégrations',
      contact: 'Contact',
      altRoutific: 'Alternative à Routific',
      altShipday: 'Alternative à Shipday',
      altOnfleet: 'Alternative à Onfleet',
      altTookan: 'Alternative à Tookan',
      altCircuit: 'Alternative à Circuit',
      altOptimoroute: 'Alternative à OptimoRoute',
      altRoute4me: 'Alternative à Route4Me',
      altBringg: 'Alternative à Bringg',
      altDetrack: 'Alternative à Detrack',
      altLocus: 'Alternative à Locus',
      altDispatchtrack: 'Alternative à DispatchTrack',
      altTrackPod: 'Alternative à Track-POD',
      altUpper: 'Alternative à Upper',
      altZeo: 'Alternative à Zeo',
    },
    language: 'Langue',
    terms: 'Conditions d\'utilisation',
    privacy: 'Politique de confidentialité',
    rights: 'Tous droits réservés.',
    location: { title: 'Notre adresse', eyebrow: 'Siège social', hq: 'Siège Geofleet', cta: 'Ouvrir dans Maps', contact: 'Nous contacter' },
  },
};
